import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { onBeforeUnmount, onMounted, useTemplateRef, watch } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FormLocker',
    props: {
        message: { type: String, required: true },
        lock: Boolean,
    },
    setup(__props) {
        const props = __props;
        const element = useTemplateRef('element');
        const watcher = watch([() => [props.lock, props.message]], updateLock);
        onMounted(updateLock);
        onBeforeUnmount(() => watcher.stop());
        function updateLock() {
            element.value?.setCustomValidity(props.lock ? props.message : '');
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("input", {
                type: "text",
                ref_key: "element",
                ref: element,
                tabindex: "-1"
            }, null, 512 /* NEED_PATCH */));
        };
    }
});
